import React, { useContext, useState } from "react";

import { Alert, DialogContentText, Snackbar } from "@mui/material";

import { User } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { confirmUser } from "api/endpoints/user";
import { callOptionsHeaders } from "api/helpers";
import ConfirmDialog from "components/shared/confirm-dialog";
import { DEFAULT_SNACKBAR_DURATION } from "constants/index";
import { SnackbarContext } from "context/snackbar-context";
import { UserContext } from "context/user-context";
import { toUUID } from "helpers/s12-helpers";

interface ConfirmUserDialogProps {
  userId: string;
  regionCode: string;
  open: boolean;
  setOpen: (newOpen: boolean) => void;
}

const ConfirmUserDialog = ({
  userId,
  regionCode,
  open,
  setOpen,
}: ConfirmUserDialogProps) => {
  const [successOpen, setSuccessOpen] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const { showError } = useContext(SnackbarContext);

  const handleSuccessConfirmUser = () => {
    const updatedUser = new User({
      ...user,
    });

    if (updatedUser.flags) {
      updatedUser.flags.isActive = true;
      updatedUser.flags.isConfirmed = true;
      setUser(updatedUser);
    }
  };

  const handleSendButtonPress = () => {
    confirmUser(
      { userId: toUUID(userId) },
      callOptionsHeaders(regionCode, userId),
    )
      .then(() => {
        setSuccessOpen(true);
        handleSuccessConfirmUser();
      })
      .catch(showError);
  };

  return (
    <>
      <ConfirmDialog
        title="Confirm User"
        open={open}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Confirm"
        setOpen={setOpen}
        onConfirm={handleSendButtonPress}
      >
        <DialogContentText>
          This will bypass the user&apos;s confirmation email step. Do you want
          to continue?
        </DialogContentText>
      </ConfirmDialog>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={successOpen}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={() => setSuccessOpen(false)}
        data-testid="confirm-user-dialog-success"
      >
        <Alert severity="success" variant="filled">
          User Confirmed
        </Alert>
      </Snackbar>
    </>
  );
};
export default ConfirmUserDialog;
